import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useIsMobileDevice } from "./mobileDevice";

interface MobileDeviceRouteProps {
  children?: ReactNode;
  desktopPath?: string;
}

/**
 * 데스크톱 라우트 가드. 모바일 기기만 `/mobile`로 보냅니다.
 * 데스크톱 브라우저는 창 폭과 무관하게 데스크톱 라우트를 유지합니다.
 */
export default function MobileDeviceRoute({
  children,
  desktopPath,
}: MobileDeviceRouteProps) {
  const usesMobileLayout = useIsMobileDevice();

  if (usesMobileLayout) {
    return <Navigate to="/mobile" replace />;
  }

  if (desktopPath) {
    return <Navigate to={desktopPath} replace />;
  }

  return <>{children}</>;
}
